import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Container, Table, Button } from "react-bootstrap";
import api from "../../../axiosConfig";

export default function ComenziProdPrint() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [comanda, setComanda] = useState(null);
  const [firma, setFirma] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [resFirma, resCmd] = await Promise.all([
          api.get("/firma"),
          api.get(`/comenzi-prod/${id}`)
        ]);
        if (resFirma.data?.items?.length > 0) {
          setFirma(resFirma.data.items[0]);
        }
        setComanda(resCmd.data);
      } catch (err) {
        console.error("Error fetching data for print", err);
      }
    };
    fetchData();
  }, [id]);

  if (!comanda) return <div className="text-center mt-5">Se încarcă datele pentru tipărire...</div>;

  return (
    <Container fluid className="bg-white text-dark p-4" style={{ minHeight: "100vh" }}>
      <div className="d-print-none mb-3">
        <Button variant="secondary" className="me-2" onClick={() => navigate(-1)}>
          Înapoi
        </Button>
        <Button variant="primary" onClick={() => window.print()}>
          Printează
        </Button>
      </div>

      <div className="print-content" style={{ maxWidth: '800px', margin: '0 auto', fontSize: '14px' }}>
        <div className="d-flex justify-content-between mb-4 border-bottom pb-3">
          <div>
            <h4 className="mb-1">{firma?.bxdenumire || "Firma Mea"}</h4>
            <div>CUI: {firma?.bxcodfiscal}</div>
            <div>Reg. Com: {firma?.bxrecom}</div>
            <div>Sediul: {firma?.bxadresa}</div>
          </div>
          <div className="text-end">
            <h3 className="mb-1">COMANDĂ DE PRODUCȚIE</h3>
            <h5 className="text-muted">Seria CP / Nr. {comanda.numar_document}</h5>
            <div>Data: {new Date(comanda.data_lansare).toLocaleDateString('ro-RO')}</div>
          </div>
        </div>

        <div className="mb-4">
          <h5 className="border-bottom pb-2 mb-3">Detalii Produs Finit</h5>
          <div className="row">
            <div className="col-6">
              <strong>Cod Produs Finit (ID):</strong> {comanda.produs_finit_id}
            </div>
            <div className="col-6">
              <strong>Stare Comandă:</strong> {comanda.stare}
            </div>
            <div className="col-6 mt-2">
              <strong>Cantitate Planificată:</strong> {comanda.cantitate_planificata}
            </div>
            <div className="col-6 mt-2">
              <strong>Cantitate Realizată:</strong> {comanda.cantitate_realizata}
            </div>
          </div>
        </div>

        <h5 className="border-bottom pb-2 mb-3">Necesar Materii Prime</h5>
        <Table bordered size="sm">
          <thead className="table-light">
            <tr>
              <th>Nr. Crt</th>
              <th>Cod Material (ID)</th>
              <th className="text-end">Cantitate Necesară</th>
              <th className="text-end">Eliberat / Consumat</th>
            </tr>
          </thead>
          <tbody>
            {(comanda.linii || []).map((linie, idx) => (
              <tr key={linie.id}>
                <td>{idx + 1}</td>
                <td>{linie.materie_prima_id}</td>
                <td className="text-end">{linie.cantitate_necesara}</td>
                <td className="text-end fw-bold">{linie.cantitate_consumata}</td>
              </tr>
            ))}
            {(!comanda.linii || comanda.linii.length === 0) && (
              <tr>
                <td colSpan="4" className="text-center text-muted">Nu există linii de materii prime.</td>
              </tr>
            )}
          </tbody>
        </Table>

        <div className="mt-5 pt-4 d-flex justify-content-between border-top">
          <div className="text-center" style={{ width: '200px' }}>
            <strong>Întocmit,</strong>
            <div className="mt-4 border-bottom"></div>
          </div>
          <div className="text-center" style={{ width: '200px' }}>
            <strong>Responsabil Producție,</strong>
            <div className="mt-4 border-bottom"></div>
          </div>
        </div>
      </div>
    </Container>
  );
}
